import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { UtilService } from './util.service';
import { LoaderService } from './loader.service';

@Injectable()
export class AuditDashboardService {

  constructor(
    private http: HttpService, 
    private utilService: UtilService,
    private loaderService: LoaderService
    ) { }

    getReportForDimension1(data) {
      return this.http.post(`/audit/dashboard/reports/dimension/1`, data)
        .map(res => res.json())
        .catch(this.utilService.handleError);
    }

    getReportForDimension2(data) {
      return this.http.post(`/audit/dashboard/reports/dimension/2`, data)
        .map(res => res.json())
        .catch(this.utilService.handleError);
    }

    getReportForDimension3(data) {
      return this.http.post(`/audit/dashboard/reports/dimension/3`, data)
        .map(res => res.json())
        .catch(this.utilService.handleError);
    }

    getReportForDimension4(data) {
      return this.http.get(`/audit/dashboard/reports/dimension/4/${data}`, {})
        .map(res => res.json())
        .catch(this.utilService.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/_services/audit-dashboard.service.ts